<div [ngClass]="{'alert-label-container': messageSecondPart.length === 0,
                 'alert-label-container-line-one': messageSecondPart.length > 0}">
    {{ message }}
</div>
<div *ngIf="messageSecondPart.length > 0" class="alert-label-container-line-two">
    {{ messageSecondPart }}
</div>